import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getUser } from '../../utils/tokens';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import InlineEditor from 'ckeditor5-custom-build/build/ckeditor';


// Comment to trigger build
const getResourceURL = (resourceId, clientId) => `/resource/v1/resources/${resourceId}/clients/${clientId}`;

const ResourceInlineView = () => {
	const [resource, setResource] = useState(null);
	let { resourceId } = useParams();
	const currentUser = getUser();

	useEffect(() => {
		const fetchResource = async () => {
			const response = await axios({
				method: 'GET',
				url: getResourceURL(resourceId, currentUser.clientIdNum),
			});

			setResource(response.data);
			console.log(response.data);
		};

		if (resourceId) {
			fetchResource().catch(console.error);
		}
	}, [resourceId]);

	if (resourceId && !resource) {
		return <div></div>;
	}

	if (resource) {
		return (
			<div className="border-2 bg-white ml-4 rounded-lg">
				<CKEditor
					onReady={editor => {
						const toolbarElement = editor.ui.view.toolbar.element;
						toolbarElement.style.display = 'none';
						const myFeatureLockId = Symbol('my-feature');
						editor.enableReadOnlyMode(myFeatureLockId);
					}}
					editor={InlineEditor}
					data={resource.inline}
					readOnly={true}
					config={{ toolbar: [], isReadOnly: true }}
				/>
			</div>
		);
	}
};

export default ResourceInlineView;
